// Third Party
import * as $ from 'jquery';

// Mixins
import { walkerSitterMixins } from '@/app/mixins/components/walker-sitter-mixins';

export default {
    name: 'WalkerSitterModal',
    mixins: [ walkerSitterMixins ],
    props: {
        modalContent: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            role: {
                WASI: 'Walker and Sitter',
                WALK: 'Walker',
                SITT: 'Sitter'
            }
        }
    },
    beforeDestroy() {
        this.closeModal();
    },
    methods: {
        show() {
            $(this.$refs.walkerSitterModal).modal('show');
        },
        closeModal() {
            $(this.$refs.walkerSitterModal).modal('hide');
        },
        getDisplayAddress(address) {
            if(address) {
                let tempAddress = address.split(" ");
                return `${tempAddress[tempAddress.length - 2]} ${tempAddress[tempAddress.length - 1]}`;
            } else {
                return 'no address';
            }
        },
        mobileNumberFormat(mobileNumber) {
            if(mobileNumber) {
                let data = mobileNumber.split('');
				data.splice(4, 0, '-');
				return data.join('');
            } else {
                return '';
            }
        },
		showEmail(email) {
			if (email) {
				window.location.href = `mailto:${email}`;
			}
		},
        callBackSaveFavorite(list) {
            this.$emit('callBackSaveFavorite', list);
        },
        getImage(src) {
            return src || require("@/assets/images/_shared/default-user-pic.png");
        },
    }
}